export default __webpack_public_path__ + "static/media/load.64de3731.mp4";